import { http } from "@/http/axios.js";
// 列表
export function getListAPI(params) {
  return http({
    url: "/admin/finance/bill/page",
    method: "get",
    params,
  });
}
